"use client";

import { useLanguage } from "@/contexts/LanguageContext";

const Tech = () => {
  const { translations, currentLang } = useLanguage();
  const t = translations[currentLang];
  const products = [
    {
      title: t.product1Title,
      desc: t.product1Desc,
    },
    {
      title: t.product2Title,
      desc: t.product2Desc,
    },
    {
      title: t.product3Title,
      desc: t.product3Desc,
    },
    {
      title: t.product4Title,
      desc: t.product4Desc,
    },
    {
      title: t.product5Title,
      desc: t.product5Desc,
    },
    {
      title: t.product6Title,
      desc: t.product6Desc,
    },
  ];

  const technologies = [
    {
      title: t.nlpTitle,
      desc: t.nlpDesc,
      // title: "Instruction - Following",
      // desc: "사용자의 의도에 부합하는 답변 생성",
    },
    {
      title: t.cvTitle,
      desc: t.cvDesc,
      // title: "Reward Model",
      // desc: "생성한 답변에 대한 사람의 피드백 점수를 반영함",
    },
    {
      title: t.mlTitle,
      desc: t.mlDesc,
    },
    {
      title: t.automlTitle,
      desc: t.automlDesc,
    },
  ];

  return (
    <section
      className="min-h-screen py-24 px-4 md:px-12 flex flex-col justify-center items-center relative bg-black bg-opacity-80"
      style={{
        backgroundImage: "url('/assets/aiart2.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
      }}
    >
      <div className="absolute inset-0 bg-[rgba(0,0,0,0.5)] z-10"></div>

      <div className="relative z-20 max-w-7xl text-center">
        <h2 className="text-4xl md:text-6xl lg:text-7xl mb-8 text-[#00c4ff] font-bold">
          {t.techTitle}
        </h2>

        <div className="space-y-6 text-lg md:text-xl opacity-90 mb-12">
          <p className="mb-6 font-medium">{t.techDesc1}</p>

          <h3 className="text-xl font-bold text-[white] mb-4">
            {t.techProductsTitle}
          </h3>
          <p className="mb-8 font-medium">{t.techProductsDesc}</p>
        </div>

        {/* 제품 그리드 - 기존 HTML 스타일과 동일하게 */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {products.map((product, index) => (
            <div
              key={index}
              className="bg-[rgba(0,196,255,0.06)] p-8 rounded-2xl border-2 border-[rgba(0,196,255,0.18)] backdrop-blur-sm hover:border-[#00c4ff] transition-all duration-300 hover:-translate-y-2 text-left"
            >
              <h3 className="text-2xl font-bold mb-3 text-[#00c4ff]">
                {product.title}
              </h3>
              <p className="text-xl leading-relaxed mb-5">{product.desc}</p>
            </div>
          ))}
        </div>

        {/* 기술 그리드 - 기존 HTML 스타일과 동일하게 */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {technologies.map((tech, index) => (
            <div
              key={index}
              className="bg-[rgba(0,196,255,0.06)] p-8 rounded-2xl border-2 border-[rgba(0,196,255,0.18)] backdrop-blur-sm hover:border-[#00c4ff] transition-all duration-300 hover:-translate-y-2 text-left"
            >
              <h3 className="text-2xl font-bold mb-3 text-[#00c4ff]">
                {tech.title}
              </h3>
              <p className="text-xl leading-relaxe mb-5">{tech.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Tech;
